import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from './routes';
import auth from '../store/auth';

Vue.use(VueRouter);

// configure router
const router = new VueRouter({
  //base: "/schadenapp/",
  routes, // short for routes: routes
  linkActiveClass: 'active',
  //mode: 'history', // this remove the # from the route with all ugly problems...
  scrollBehavior: (to, from ,savedPosition) => {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return { selector: to.hash };
    }
    return { x: 0, y: 0 };
  }
});

router.beforeEach((to, from, next) => {
  console.log(to);
  console.log(from);
  console.log(next);
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
//    console.log("checking route....");
//    console.log(auth.state.account ? true : false);
    if (auth.state.account  ? false : true ) {
      //console.log(record);
      //console.log("user not logged in");
      //next()
      next( { path: '/login' } );
    } else {
//      console.log("user logged in");
      next() // go to wherever I'm going
    }
  } else {
    next() // does not require auth, make sure to always call next()!
  }
  if (to.matched.some(record => record.meta.hideForAuth)) {
    if (auth.state.account  ? true : false ) {
        next({ path: '/portal/home' });
    } else {
        next();
    }
} else {
    next();
}
})

export default router;
